export default [
  {
    key: 'increasement',
    sortable: true,
    sortField: 'createdAt',
    label: 'label.no',
    thClass: 'w-50px',
    thStyle: { width: '80px' },
  },
  {
    key: 'employee',
    sortable: false,
    label: 'breadcrumb.employee',
    stickyColumn: true,
    variant: 'light',
    thStyle: { width: '200px' },
  },
  {
    key: 'date',
    label: 'field.date',
    thStyle: { width: '350px' },
  },
  {
    key: 'remark',
    label: 'field.remark',
    thStyle: { width: '300px' },
  },
  {
    key: 'actions',
    label: 'general.action',
    thStyle: { width: '150px' },
  },
]
